const AUTO_PASSENGER_POSITIONS = ['Front Seat', 'Back Seat'] as const;

export default AUTO_PASSENGER_POSITIONS;
